import * as React from 'react';
import Divider from '@mui/material/Divider';
import Hero from '../components/homepage/Hero';
import LogoCollection from '../components/homepage/LogoCollection';
import Highlights from '../components/homepage/Highlights';
import Pricing from '../components/homepage/Pricing';
import Features from '../components/homepage/Features';
import FAQ from '../components/homepage/FAQ';
import Footer from '../components/homepage/Footer';
import AppTheme from '../AppTheme';

export default function MarketingPage(props) {
  return (
    <AppTheme {...props}>
      <Hero />
      <div>
        {/* <LogoCollection /> */}
        <Features />
        <Divider />
        <Divider />
        <Highlights />
        <Divider />
        <Pricing />
        <Divider />
        <FAQ />
        <Divider />
        <Footer />
      </div>
    </AppTheme>
  );
}
